import { FetchRequest } from '@rails/request.js'

interface DestroyArgs {
  id: string
  submissionContainerId: string
}

// Ends a drawer's visit without submitting: deletes its locks and the drafts under them.
export function destroy({ id, submissionContainerId }: DestroyArgs) {
  const endpoint = `/submission_containers/${submissionContainerId}/container_sessions/${id}`

  // keepalive lets the request outlive the drawer, or the page, that sent it.
  return new FetchRequest('delete', endpoint, { keepalive: true }).perform()
}
